const FlagColombia = ({ ...props }) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <mask
                id="mask0_695_494"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="16"
                height="16"
            >
                <path
                    d="M8.04307 15.6263C12.3519 15.6263 15.8449 12.2043 15.8449 7.98303C15.8449 3.76175 12.3519 0.339722 8.04307 0.339722C3.73422 0.339722 0.241211 3.76175 0.241211 7.98303C0.241211 12.2043 3.73422 15.6263 8.04307 15.6263Z"
                    fill="#C4C4C4"
                />
            </mask>
            <g mask="url(#mask0_695_494)">
                <path d="M22 0H-6V8H22V0Z" fill="#F3D031" />
                <path d="M22 8H-6V12.0085H22V8Z" fill="#313F88" />
                <path d="M22 12.0085H-6V16.017H22V12.0085Z" fill="#BC2433" />
            </g>
        </svg>
    )
}

export default FlagColombia
